const originUrl = window.location.origin;
let apiUrl;
let lmsApiUrl;
let communityUrl;

if (originUrl === "https://app.sustainchange.test") {
  apiUrl = "https://sustainchange.test/wp-json/";
  lmsApiUrl = "https://learn.sustainchange.test/wp-json/";
  communityUrl = 'https://community.test';
} else if (originUrl === "https://app.staging.sustainchange.se") {
  apiUrl = "https://staging.sustainchange.se/wp-json/";
  lmsApiUrl = "https://learn.staging.sustainchange.se/wp-json/";
  communityUrl = 'https://staging-community.kinsta.cloud';
} else if (originUrl === "https://app.sustainchange.se") {
  apiUrl = "https://sustainchange.se/wp-json/";
  lmsApiUrl = "https://learn.sustainchange.se/wp-json/";
  communityUrl = 'https://community.sustainchange.se';
}

const wysiwygToolbarOptions = {
  options: [
    "inline",
    "blockType",
    // "fontSize",
    // "fontFamily",
    "list",
    "textAlign",
    "colorPicker",
    "link",
    // "embedded",
    // "emoji",
    // "image",
    // "remove",
    // "history",
  ],
  inline: {
    options: ["bold", "italic", "underline", "monospace"],
  },
};

const configVars = {
  apiUrl: apiUrl,
  lmsApiUrl: lmsApiUrl,
  auth: "c3VzdGFpbmt1bmQ6a25lMiBTU3BmIDFSOTggcFlmMiBMNE1QIDhEa1U=",
  boardCreationLimit: 100,
  wysiwygToolbarOptions: wysiwygToolbarOptions,
  communityUrl: communityUrl
};

export default configVars;
